// @ts-nocheck
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Scalars = {
    String: string,
    Int: number,
    ID: string,
    Float: number,
    Boolean: boolean,
    Upload: any,
}

export interface FrontendQuery {
    getDIYProjectIndexListing: DIYProjectIndex
    getStylist: (Stylist | null)
    getStylistListing: StylistConnection
    getDIYProject: (DIYProject | null)
    getDIYProjectListing: DIYProjectConnection
    getBlogCategory: (BlogCategory | null)
    getBlogCategoryListing: BlogCategoryConnection
    getFaqItem: (FaqItem | null)
    getFaqItemListing: FaqItemConnection
    getFaqCategory: (FaqCategory | null)
    getFaqCategoryListing: FaqCategoryConnection
    getPage: (Page | null)
    getPageListing: PageConnection
    getAttributeDescription: (AttributeDescription | null)
    getAttributeDescriptionListing: AttributeDescriptionConnection
    miniSearch: Index[]
    DIYProjectForm: (DIYProject | null)
    relatedDiyProjects: DIYProjectConnection
    edgeBandQuery: (PublicEdgeBand | null)
    edgeBandsQuery: PublicEdgeBandIndexType
    ping: Scalars['String']
    __typename: 'FrontendQuery'
}

export interface DIYProjectIndex {
    aggregations: Aggregation[]
    connection: DIYProjectConnection
    __typename: 'DIYProjectIndex'
}

export interface Aggregation {
    label: Scalars['String']
    value: Scalars['String']
    options: AggregationOption[]
    __typename: 'Aggregation'
}

export interface AggregationOption {
    value: Scalars['String']
    label: Scalars['String']
    count: Scalars['Int']
    __typename: 'AggregationOption'
}

export interface DIYProjectConnection {
    /** Edges of the connection */
    edges: (DIYProjectEdge[] | null)
    /** Page info of the connection */
    pageInfo: (PageInfo | null)
    /** Total count of items in the connection. */
    totalCount: (Scalars['Int'] | null)
    __typename: 'DIYProjectConnection'
}

export interface DIYProjectEdge {
    /** Node of the Edge */
    node: DIYProject
    /** The edge cursor */
    cursor: Scalars['String']
    __typename: 'DIYProjectEdge'
}

export interface DIYProject {
    version: (Scalars['String'] | null)
    baseLanguage: (Scalars['String'] | null)
    firstname: (Scalars['String'] | null)
    keywords: (Scalars['String'] | null)
    projectLevel: (Scalars['Float'] | null)
    images: Image[]
    title: (Scalars['String'] | null)
    urlKey: (Scalars['String'] | null)
    customUrlKey: (Scalars['String'] | null)
    content: (Scalars['String'] | null)
    stepByStepGuide: StepByStepGuide[]
    orderStars: (Scalars['Float'] | null)
    deliveryStars: (Scalars['Float'] | null)
    generalStars: (Scalars['Float'] | null)
    review: (Scalars['String'] | null)
    colorCode: (Scalars['String'] | null)
    tips: (Scalars['String'] | null)
    metaTitle: (Scalars['String'] | null)
    metaDescription: (Scalars['String'] | null)
    metaKeywords: (Scalars['String'] | null)
    translated: Scalars['Boolean']
    active: Scalars['Boolean']
    price: (Scalars['Float'] | null)
    shippingPrice: (Scalars['Float'] | null)
    isSalable: Scalars['Boolean']
    hasRestpieces: Scalars['Boolean']
    woodCategories: Category[]
    woodTypes: BlogCategory[]
    spaces: BlogCategory[]
    endProducts: BlogCategory[]
    diyType: BlogCategory[]
    categoryBrands: BlogCategory[]
    products: Product[]
    styles: BlogCategory[]
    famousDesigners: BlogCategory[]
    knownFrom: BlogCategory[]
    status: (Scalars['String'] | null)
    highlightable: Scalars['Boolean']
    cartHash: (Scalars['String'] | null)
    projectCode: (Scalars['String'] | null)
    wordpressPostId: (Scalars['String'] | null)
    shortUrl: ShortUrl[]
    urlIdentifier: (Scalars['String'] | null)
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    url: (Scalars['String'] | null)
    hreflang: Hreflang[]
    __typename: 'DIYProject'
}

export interface Image {
    id: Scalars['ID']
    fullpath: Scalars['String']
    filename: Scalars['String']
    __typename: 'Image'
}

export interface StepByStepGuide {
    stepDescription: (Scalars['String'] | null)
    phase: (Scalars['String'] | null)
    __typename: 'StepByStepGuide'
}

export interface Category {
    enabled: Scalars['Boolean']
    name: (Scalars['String'] | null)
    urlKey: (Scalars['String'] | null)
    description: (Scalars['String'] | null)
    metaTitle: (Scalars['String'] | null)
    metaDescription: (Scalars['String'] | null)
    metaKeywords: (Scalars['String'] | null)
    image: (Image | null)
    urlIdentifier: Scalars['String']
    isUsedForSeo: (Scalars['String'] | null)
    displayType: (Scalars['String'] | null)
    blocks: CategorySeoBlock[]
    showFilters: Scalars['Boolean']
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    url: (Scalars['String'] | null)
    hreflang: Hreflang[]
    __typename: 'Category'
}

export interface CategorySeoBlock {
    title: (Scalars['String'] | null)
    content: (Scalars['String'] | null)
    __typename: 'CategorySeoBlock'
}

export type Children = (Product | Sheet | Category | Page | FaqItem | FaqCategory | Stylist | DIYProject | BlogCategory) & { __isUnion?: true }

export interface Product {
    name: (Scalars['String'] | null)
    description: (Scalars['String'] | null)
    shortDescription: (Scalars['String'] | null)
    status: (Scalars['String'] | null)
    urlkey: (Scalars['String'] | null)
    customUrlKey: (Scalars['String'] | null)
    categoryLabel: (Scalars['String'] | null)
    visibility: (Scalars['String'] | null)
    calculatedPrice: (Scalars['String'] | null)
    fixedPrice: (Scalars['Float'] | null)
    taxClass: (Tax | null)
    weightFee: (Scalars['Float'] | null)
    yukiLedgerAccount: (Scalars['String'] | null)
    stockMessage: (Scalars['String'] | null)
    hsCode: (Scalars['Float'] | null)
    hsCodeUnit: (Scalars['String'] | null)
    youtubeUrl: (Scalars['String'] | null)
    metaTitle: (Scalars['String'] | null)
    metaDescription: (Scalars['String'] | null)
    metaKeywords: (Scalars['String'] | null)
    specsheet: ElementMetaDataSpecsheet[]
    ean: (Scalars['String'] | null)
    sku: Scalars['String']
    urlIdentifier: (Scalars['String'] | null)
    attributeSet: Scalars['String']
    typeId: Scalars['String']
    color: (Scalars['String'] | null)
    weight: (Scalars['Float'] | null)
    brand: (Scalars['String'] | null)
    customJsonConfiguration: (Scalars['String'] | null)
    diyProjectCode: (Scalars['String'] | null)
    sampleService: (Scalars['String'] | null)
    priceType: (Scalars['String'] | null)
    cost: (Scalars['Float'] | null)
    margin: (Scalars['Float'] | null)
    minimalPrice: (Scalars['Float'] | null)
    minimalPriceCompletePanel: (Scalars['Float'] | null)
    minimalPriceThreshold: (Scalars['Float'] | null)
    quantityIncrements: (Scalars['Float'] | null)
    isInStock: Scalars['Boolean']
    alternativeProduct: (Product | null)
    stockPosition: (Scalars['String'] | null)
    deliveryOffset: (Scalars['Float'] | null)
    image: (Image | null)
    detailImage: (Image | null)
    gallery: Image[]
    sheetTypeBase: (Scalars['String'] | null)
    sheetTypeFinish: (Scalars['String'] | null)
    sheetShapes: Shape[]
    sheetFinishes: Finish[]
    sheetMandatoryFinishes: Finish[]
    sheetAvailableAbsBandColors: ((Scalars['String'] | null)[] | null)
    sheetPurchaseType: (Scalars['String'] | null)
    sheetThickness: (Scalars['Float'] | null)
    sheetUnit: (Scalars['String'] | null)
    sheetMinLength: (Scalars['Float'] | null)
    sheetMinWidth: (Scalars['Float'] | null)
    sheetOutdoor: (Scalars['String'] | null)
    sheetPrimed: Scalars['Boolean']
    sheetWaterResistant: Scalars['Boolean']
    sheetHasVisibleSide: Scalars['Boolean']
    sheetFingerprintProof: Scalars['Boolean']
    sheetColorCode: (Scalars['String'] | null)
    sheetWoodQualityMark: (Scalars['String'] | null)
    sheetGrainType: (Scalars['String'] | null)
    sheetToplayerSides: (Scalars['String'] | null)
    sheetToplayerType: (Scalars['String'] | null)
    sheetTreatmentForUse: (Scalars['String'] | null)
    sheetQualityVisual: (Scalars['String'] | null)
    sheetAppearance: (Scalars['String'] | null)
    sheetWoodStructure: (Scalars['String'] | null)
    sheetWoodUsed: (Scalars['String'] | null)
    sheetDecorative: (Scalars['String'] | null)
    sheetConnectionType: (Scalars['String'] | null)
    sheetSustainability: ((Scalars['String'] | null)[] | null)
    sheetDensity: (Scalars['String'] | null)
    sheetFormaldehydeReleaseClass: (Scalars['String'] | null)
    sheetGlue: (Scalars['String'] | null)
    sheetFireResistant: (Scalars['String'] | null)
    sheetConditionAgreement: (Scalars['String'] | null)
    sheetConditionAgreementText: (Scalars['String'] | null)
    sheetPositiveNegative: (Scalars['String'] | null)
    sheetWoodApplications: (Scalars['String'] | null)
    sheetApplyBeltSize: (Scalars['String'] | null)
    sheetVeneerThickness: (Scalars['Float'] | null)
    sheetVeneerCuttingMethod: (Scalars['String'] | null)
    sheetWeightPerM3: (Scalars['Float'] | null)
    sheetJointingTechnique: (Scalars['String'] | null)
    sheetNcsColorCode: (Scalars['String'] | null)
    sheetGeneralApplication: ((Scalars['String'] | null)[] | null)
    sheetPaintability: (Scalars['String'] | null)
    sheetCore: (Scalars['String'] | null)
    sheetColorShade: (Scalars['String'] | null)
    sheetAlternativeOptiplanning: (Scalars['String'] | null)
    sheetProductionType: (Scalars['String'] | null)
    sheetProductionUnit: ((Scalars['String'] | null)[] | null)
    sheetWorkSpeed: (Scalars['String'] | null)
    sheetReverseMillingDirection: Scalars['Boolean']
    sheetPreMill: Scalars['Boolean']
    sheetTroughMill: Scalars['Boolean']
    sheetExcludeForCncProduction: (Scalars['String'] | null)
    sheetMinimumMiter: (Scalars['Float'] | null)
    sheetMaximumMiter: (Scalars['Float'] | null)
    sheetMinimumChamfering: (Scalars['Float'] | null)
    sheetMaximumChamfering: (Scalars['Float'] | null)
    sheetMinimumCompletion: (Scalars['Float'] | null)
    sheetMaximumCompletion: (Scalars['Float'] | null)
    sheetMinimumHollowprofile: (Scalars['Float'] | null)
    sheetMaximimumHollowProfile: (Scalars['Float'] | null)
    sheetMinimumQuarterRound: (Scalars['Float'] | null)
    sheetMaximumQuarterRound: (Scalars['Float'] | null)
    sheetDeliveryTime: (Scalars['String'] | null)
    accessoriesLength: (Scalars['Float'] | null)
    accessoriesWidth: (Scalars['Float'] | null)
    accessoriesHeight: (Scalars['Float'] | null)
    accessoriesDiameter: (Scalars['String'] | null)
    accessoriesBitType: (Scalars['String'] | null)
    accessoriesPackagingContent: (Scalars['Float'] | null)
    accessoriesColorCode: (Scalars['String'] | null)
    cabinetOuterWidth: (Scalars['String'] | null)
    cabinetOuterHeight: (Scalars['String'] | null)
    cabinetOuterDepth: (Scalars['String'] | null)
    plasticSoundDamping: (Scalars['Float'] | null)
    plasticLightTransmission: (Scalars['String'] | null)
    plasticUvResistant: (Scalars['String'] | null)
    plasticAcrylaatType: (Scalars['String'] | null)
    plasticWarranty: (Scalars['String'] | null)
    plasticDensityGrCm3: (Scalars['Float'] | null)
    plasticTensileNewtonMm2: (Scalars['Float'] | null)
    plasticElasticyModulusNewtonMm2: (Scalars['Float'] | null)
    plasticBuigsterkteNewtonMm2: (Scalars['Float'] | null)
    plasticCompresResistanceNewtonMm2: (Scalars['Float'] | null)
    plasticHardnessShore: (Scalars['String'] | null)
    plasticFrictionCoefficient: (Scalars['Float'] | null)
    plasticTemperatureMinUnloaded: (Scalars['Float'] | null)
    plasticTemperatureMaxUnloaded: (Scalars['Float'] | null)
    plasticLinearExpansionCoefficient: (Scalars['Float'] | null)
    plasticRelativeDielectricConstant: (Scalars['String'] | null)
    plasticDielectricLossFactor: (Scalars['String'] | null)
    plasticResistanceSpecific: (Scalars['String'] | null)
    plasticResistanceSurface: (Scalars['String'] | null)
    plasticBreakdownVoltage: (Scalars['String'] | null)
    threedimensionalTopTexture: (Image | null)
    threedimensionalSideTexture: (Image | null)
    categories: Category[]
    faqCategories: FaqCategory[]
    crossSells: Product[]
    upSells: Product[]
    relatedProducts: Product[]
    edgeBands: EdgeBand[]
    sample: (Product | null)
    tosizeFurnitureDecor: (Scalars['String'] | null)
    supplier: (Scalars['String'] | null)
    supplierSku: (Scalars['String'] | null)
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    url: (Scalars['String'] | null)
    hreflang: Hreflang[]
    __typename: 'Product'
}

export interface Tax {
    name: Scalars['String']
    percentage: (Scalars['Float'] | null)
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    __typename: 'Tax'
}

export type Parent = (Product | Category | Page | FaqItem | FaqCategory | Stylist) & { __isUnion?: true }

export interface Page {
    enabled: (Scalars['String'] | null)
    title: (Scalars['String'] | null)
    urlKey: (Scalars['String'] | null)
    customUrlKey: (Scalars['String'] | null)
    content: (Scalars['String'] | null)
    intro: (Scalars['String'] | null)
    image: (Image | null)
    metaTitle: (Scalars['String'] | null)
    metaDescription: (Scalars['String'] | null)
    includeInSitemap: (Scalars['String'] | null)
    pageRelation: pageRelationUnion[]
    blogCategory: (BlogCategory | null)
    urlIdentifier: Scalars['String']
    pageType: (Scalars['String'] | null)
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    url: (Scalars['String'] | null)
    hreflang: Hreflang[]
    __typename: 'Page'
}

export type pageRelationUnion = (FaqCategory | FaqItem | Page) & { __isUnion?: true }

export interface FaqCategory {
    enabled: Scalars['Boolean']
    title: (Scalars['String'] | null)
    faqItems: FaqItem[]
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    __typename: 'FaqCategory'
}

export interface FaqItem {
    title: (Scalars['String'] | null)
    content: (Scalars['String'] | null)
    enabled: Scalars['Boolean']
    urlKey: (Scalars['String'] | null)
    customUrlKey: (Scalars['String'] | null)
    metaTitle: (Scalars['String'] | null)
    metaDescription: (Scalars['String'] | null)
    urlIdentifier: (Scalars['String'] | null)
    image: (Image | null)
    imagePosition: (Scalars['String'] | null)
    imageSize: (Scalars['String'] | null)
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    url: (Scalars['String'] | null)
    hreflang: Hreflang[]
    __typename: 'FaqItem'
}

export interface Hreflang {
    href: Scalars['String']
    hreflang: Scalars['String']
    __typename: 'Hreflang'
}

export interface BlogCategory {
    name: (Scalars['String'] | null)
    urlKey: (Scalars['String'] | null)
    customUrlKey: (Scalars['String'] | null)
    description: (Scalars['String'] | null)
    showInMenu: Scalars['Boolean']
    enabled: (Scalars['String'] | null)
    image: (Image | null)
    metaTitle: (Scalars['String'] | null)
    metaDescription: (Scalars['String'] | null)
    metaKeywords: (Scalars['String'] | null)
    urlIdentifier: Scalars['String']
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    url: (Scalars['String'] | null)
    hreflang: Hreflang[]
    __typename: 'BlogCategory'
}

export interface Stylist {
    enabled: (Scalars['String'] | null)
    title: (Scalars['String'] | null)
    urlKey: (Scalars['String'] | null)
    customUrlKey: (Scalars['String'] | null)
    personalTitle: (Scalars['String'] | null)
    content: (Scalars['String'] | null)
    speciality: (Scalars['String'] | null)
    formTitle: (Scalars['String'] | null)
    formContent: (Scalars['String'] | null)
    metaTitle: (Scalars['String'] | null)
    metaDescription: (Scalars['String'] | null)
    metaKeywords: (Scalars['String'] | null)
    gallery: Image[]
    personalImage: (Image | null)
    personalImageClose: (Image | null)
    name: (Scalars['String'] | null)
    email: (Scalars['String'] | null)
    companyName: (Scalars['String'] | null)
    location: (Scalars['String'] | null)
    website: (Link | null)
    latlng: (Scalars['String'] | null)
    youtube: (Scalars['String'] | null)
    facebook: (Scalars['String'] | null)
    instagram: (Scalars['String'] | null)
    pinterest: (Scalars['String'] | null)
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    url: (Scalars['String'] | null)
    hreflang: Hreflang[]
    __typename: 'Stylist'
}

export interface Link {
    html: Scalars['String']
    class: (Scalars['String'] | null)
    title: (Scalars['String'] | null)
    path: Scalars['String']
    accessKey: (Scalars['String'] | null)
    anchor: Scalars['String']
    attributes: (Scalars['String'] | null)
    href: Scalars['String']
    rel: (Scalars['String'] | null)
    tabindex: (Scalars['String'] | null)
    target: (Scalars['String'] | null)
    text: (Scalars['String'] | null)
    __typename: 'Link'
}

export interface ElementMetaDataSpecsheet {
    element: (Asset | null)
    variant: (Scalars['String'] | null)
    __typename: 'ElementMetaDataSpecsheet'
}

export interface Asset {
    id: Scalars['ID']
    fullpath: Scalars['String']
    filename: Scalars['String']
    __typename: 'Asset'
}

export interface Shape {
    code: (Scalars['String'] | null)
    enabled: Scalars['Boolean']
    name: (Scalars['String'] | null)
    description: (Scalars['String'] | null)
    categoryUrl: (Scalars['String'] | null)
    sortOrder: (Scalars['Float'] | null)
    maxLength: (Scalars['Float'] | null)
    maxWidth: (Scalars['Float'] | null)
    price: Scalars['Float']
    image3d: (Image | null)
    image2d: (Image | null)
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    __typename: 'Shape'
}

export interface Finish {
    code: (Scalars['String'] | null)
    name: (Scalars['String'] | null)
    description: (Scalars['String'] | null)
    shapeEnabled: Scalars['Boolean']
    categoryUrl: (Scalars['String'] | null)
    disallowedShapes: Shape[]
    price: (Scalars['Float'] | null)
    image2d: (Image | null)
    image3d: (Image | null)
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    __typename: 'Finish'
}

export interface EdgeBand {
    name: (Scalars['String'] | null)
    enabled: Scalars['Boolean']
    price: (Scalars['String'] | null)
    fixedPrice: (Scalars['Float'] | null)
    taxClass: (Tax | null)
    width: (Scalars['Float'] | null)
    thickness: (Scalars['Float'] | null)
    stockPosition: (Scalars['String'] | null)
    cuttable: Scalars['Boolean']
    image: (Image | null)
    material: (Scalars['String'] | null)
    decor: (Scalars['String'] | null)
    surface: (Scalars['String'] | null)
    color: (Scalars['String'] | null)
    priceType: (Scalars['String'] | null)
    cost: (Scalars['Float'] | null)
    margin: (Scalars['Float'] | null)
    productType: Scalars['String']
    sku: Scalars['String']
    minOrderLength: (Scalars['Float'] | null)
    articleId: (Scalars['String'] | null)
    productId: (Scalars['String'] | null)
    url: (Scalars['String'] | null)
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    __typename: 'EdgeBand'
}

export interface Sheet {
    isActive: Scalars['Boolean']
    isDefault: Scalars['Boolean']
    brand: (Scalars['String'] | null)
    stockPosition: (Scalars['String'] | null)
    productionUnit: ((Scalars['String'] | null)[] | null)
    product: (Product | null)
    priceType: (Scalars['String'] | null)
    cost: (Scalars['Float'] | null)
    margin: (Scalars['Float'] | null)
    marginCompletePanel: (Scalars['Float'] | null)
    calculatedPrice: (Scalars['String'] | null)
    calculatedPriceM2CompletePanel: (Scalars['String'] | null)
    fixedPrice: (Scalars['Float'] | null)
    taxClass: (Tax | null)
    weightFee: (Scalars['Float'] | null)
    supplier: (Scalars['String'] | null)
    supplierProductName: (Scalars['String'] | null)
    supplierSku: (Scalars['String'] | null)
    supplierProductUrl: (Scalars['String'] | null)
    manufacturerProductUrl: (Scalars['String'] | null)
    length: Scalars['Float']
    width: Scalars['Float']
    thickness: (Scalars['Float'] | null)
    weight: (Scalars['Float'] | null)
    deliveryOffset: (Scalars['Float'] | null)
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    __typename: 'Sheet'
}

export interface ShortUrl {
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    __typename: 'ShortUrl'
}


/** Information about pagination in a connection. */
export interface PageInfo {
    /** When paginating forwards, are there more items? */
    hasNextPage: Scalars['Boolean']
    /** When paginating backwards, are there more items? */
    hasPreviousPage: Scalars['Boolean']
    /** When paginating backwards, the cursor to continue. */
    startCursor: (Scalars['String'] | null)
    /** When paginating forwards, the cursor to continue. */
    endCursor: (Scalars['String'] | null)
    __typename: 'PageInfo'
}

export type SortOrder = 'ASC' | 'DESC'

export interface StylistConnection {
    /** Edges of the connection */
    edges: (StylistEdge[] | null)
    /** Page info of the connection */
    pageInfo: (PageInfo | null)
    /** Total count of items in the connection. */
    totalCount: (Scalars['Int'] | null)
    __typename: 'StylistConnection'
}

export interface StylistEdge {
    /** Node of the Edge */
    node: Stylist
    /** The edge cursor */
    cursor: Scalars['String']
    __typename: 'StylistEdge'
}

export interface BlogCategoryConnection {
    /** Edges of the connection */
    edges: (BlogCategoryEdge[] | null)
    /** Page info of the connection */
    pageInfo: (PageInfo | null)
    /** Total count of items in the connection. */
    totalCount: (Scalars['Int'] | null)
    __typename: 'BlogCategoryConnection'
}

export interface BlogCategoryEdge {
    /** Node of the Edge */
    node: BlogCategory
    /** The edge cursor */
    cursor: Scalars['String']
    __typename: 'BlogCategoryEdge'
}

export interface FaqItemConnection {
    /** Edges of the connection */
    edges: (FaqItemEdge[] | null)
    /** Page info of the connection */
    pageInfo: (PageInfo | null)
    /** Total count of items in the connection. */
    totalCount: (Scalars['Int'] | null)
    __typename: 'FaqItemConnection'
}

export interface FaqItemEdge {
    /** Node of the Edge */
    node: FaqItem
    /** The edge cursor */
    cursor: Scalars['String']
    __typename: 'FaqItemEdge'
}

export interface FaqCategoryConnection {
    /** Edges of the connection */
    edges: (FaqCategoryEdge[] | null)
    /** Page info of the connection */
    pageInfo: (PageInfo | null)
    /** Total count of items in the connection. */
    totalCount: (Scalars['Int'] | null)
    __typename: 'FaqCategoryConnection'
}

export interface FaqCategoryEdge {
    /** Node of the Edge */
    node: FaqCategory
    /** The edge cursor */
    cursor: Scalars['String']
    __typename: 'FaqCategoryEdge'
}

export interface PageConnection {
    /** Edges of the connection */
    edges: (PageEdge[] | null)
    /** Page info of the connection */
    pageInfo: (PageInfo | null)
    /** Total count of items in the connection. */
    totalCount: (Scalars['Int'] | null)
    __typename: 'PageConnection'
}

export interface PageEdge {
    /** Node of the Edge */
    node: Page
    /** The edge cursor */
    cursor: Scalars['String']
    __typename: 'PageEdge'
}

export interface AttributeDescription {
    attributeCode: Scalars['String']
    title: (Scalars['String'] | null)
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    __typename: 'AttributeDescription'
}

export interface AttributeDescriptionConnection {
    /** Edges of the connection */
    edges: (AttributeDescriptionEdge[] | null)
    /** Page info of the connection */
    pageInfo: (PageInfo | null)
    /** Total count of items in the connection. */
    totalCount: (Scalars['Int'] | null)
    __typename: 'AttributeDescriptionConnection'
}

export interface AttributeDescriptionEdge {
    /** Node of the Edge */
    node: AttributeDescription
    /** The edge cursor */
    cursor: Scalars['String']
    __typename: 'AttributeDescriptionEdge'
}

export interface Index {
    name: Scalars['String']
    code: Scalars['String']
    items: Children[]
    __typename: 'Index'
}

export interface PublicEdgeBand {
    id: Scalars['ID']
    name: (Scalars['String'] | null)
    price: (Scalars['String'] | null)
    width: (Scalars['Float'] | null)
    thickness: (Scalars['Float'] | null)
    cuttable: (Scalars['Boolean'] | null)
    image: (Image | null)
    material: (Scalars['String'] | null)
    decor: (Scalars['String'] | null)
    surface: (Scalars['String'] | null)
    color: (Scalars['String'] | null)
    sku: Scalars['String']
    minOrderLength: (Scalars['Float'] | null)
    children: Children[]
    parent: (Parent | null)
    parentId: Scalars['ID']
    __typename: 'PublicEdgeBand'
}

export interface PublicEdgeBandIndexType {
    aggregations: Aggregation[]
    available: PublicEdgeBandConnection
    matching: PublicEdgeBand[]
    __typename: 'PublicEdgeBandIndexType'
}

export interface PublicEdgeBandConnection {
    pageInfo: PageInfo
    totalCount: Scalars['Int']
    edges: (PublicEdgeBandEdge[] | null)
    __typename: 'PublicEdgeBandConnection'
}

export interface PublicEdgeBandEdge {
    node: PublicEdgeBand
    cursor: Scalars['String']
    __typename: 'PublicEdgeBandEdge'
}

export interface FrontendMutation {
    submitAIProject: SubmitAIProjectResult
    __typename: 'FrontendMutation'
}

export interface SubmitAIProjectResult {
    project: DIYProject
    __typename: 'SubmitAIProjectResult'
}

export type Query = FrontendQuery
export type Mutation = FrontendMutation

export interface FrontendQueryGenqlSelection{
    getDIYProjectIndexListing?: (DIYProjectIndexGenqlSelection & { __args: {after?: (Scalars['String'] | null), first?: (Scalars['Int'] | null), before?: (Scalars['String'] | null), last?: (Scalars['Int'] | null), defaultLanguage: Scalars['String'], filter?: (AggregationInput[] | null), query?: (Scalars['String'] | null), category?: (Scalars['ID'] | null)} })
    getStylist?: (StylistGenqlSelection & { __args: {id: Scalars['ID'], defaultLanguage: Scalars['String']} })
    getStylistListing?: (StylistConnectionGenqlSelection & { __args: {after?: (Scalars['String'] | null), first?: (Scalars['Int'] | null), before?: (Scalars['String'] | null), last?: (Scalars['Int'] | null), defaultLanguage: Scalars['String'], sortBy?: (Scalars['String'] | null), sortOrder?: (SortOrder | null), filter?: (Scalars['String'] | null)} })
    getDIYProject?: (DIYProjectGenqlSelection & { __args: {id: Scalars['ID'], defaultLanguage: Scalars['String']} })
    getDIYProjectListing?: (DIYProjectConnectionGenqlSelection & { __args: {after?: (Scalars['String'] | null), first?: (Scalars['Int'] | null), before?: (Scalars['String'] | null), last?: (Scalars['Int'] | null), defaultLanguage: Scalars['String'], sortBy?: (Scalars['String'] | null), sortOrder?: (SortOrder | null), filter?: (Scalars['String'] | null)} })
    getBlogCategory?: (BlogCategoryGenqlSelection & { __args: {id: Scalars['ID'], defaultLanguage: Scalars['String']} })
    getBlogCategoryListing?: (BlogCategoryConnectionGenqlSelection & { __args: {after?: (Scalars['String'] | null), first?: (Scalars['Int'] | null), before?: (Scalars['String'] | null), last?: (Scalars['Int'] | null), defaultLanguage: Scalars['String'], sortBy?: (Scalars['String'] | null), sortOrder?: (SortOrder | null), filter?: (Scalars['String'] | null)} })
    getFaqItem?: (FaqItemGenqlSelection & { __args: {id: Scalars['ID'], defaultLanguage: Scalars['String']} })
    getFaqItemListing?: (FaqItemConnectionGenqlSelection & { __args: {after?: (Scalars['String'] | null), first?: (Scalars['Int'] | null), before?: (Scalars['String'] | null), last?: (Scalars['Int'] | null), defaultLanguage: Scalars['String'], sortBy?: (Scalars['String'] | null), sortOrder?: (SortOrder | null), filter?: (Scalars['String'] | null)} })
    getFaqCategory?: (FaqCategoryGenqlSelection & { __args: {id: Scalars['ID'], defaultLanguage: Scalars['String']} })
    getFaqCategoryListing?: (FaqCategoryConnectionGenqlSelection & { __args: {after?: (Scalars['String'] | null), first?: (Scalars['Int'] | null), before?: (Scalars['String'] | null), last?: (Scalars['Int'] | null), defaultLanguage: Scalars['String'], sortBy?: (Scalars['String'] | null), sortOrder?: (SortOrder | null), filter?: (Scalars['String'] | null)} })
    getPage?: (PageGenqlSelection & { __args: {id: Scalars['ID'], defaultLanguage: Scalars['String']} })
    getPageListing?: (PageConnectionGenqlSelection & { __args: {after?: (Scalars['String'] | null), first?: (Scalars['Int'] | null), before?: (Scalars['String'] | null), last?: (Scalars['Int'] | null), defaultLanguage: Scalars['String'], sortBy?: (Scalars['String'] | null), sortOrder?: (SortOrder | null), filter?: (Scalars['String'] | null)} })
    getAttributeDescription?: (AttributeDescriptionGenqlSelection & { __args: {id: Scalars['ID'], defaultLanguage: Scalars['String']} })
    getAttributeDescriptionListing?: (AttributeDescriptionConnectionGenqlSelection & { __args: {after?: (Scalars['String'] | null), first?: (Scalars['Int'] | null), before?: (Scalars['String'] | null), last?: (Scalars['Int'] | null), defaultLanguage: Scalars['String'], sortBy?: (Scalars['String'] | null), sortOrder?: (SortOrder | null), filter?: (Scalars['String'] | null)} })
    miniSearch?: (IndexGenqlSelection & { __args: {query: Scalars['String'], defaultLanguage: Scalars['String']} })
    DIYProjectForm?: (DIYProjectGenqlSelection & { __args: {hash: Scalars['String']} })
    relatedDiyProjects?: (DIYProjectConnectionGenqlSelection & { __args: {after?: (Scalars['String'] | null), first?: (Scalars['Int'] | null), before?: (Scalars['String'] | null), last?: (Scalars['Int'] | null), sku: Scalars['String'], defaultLanguage: Scalars['String']} })
    edgeBandQuery?: (PublicEdgeBandGenqlSelection & { __args: {sku: Scalars['String'], defaultLanguage: Scalars['String']} })
    edgeBandsQuery?: (PublicEdgeBandIndexTypeGenqlSelection & { __args: {after?: (Scalars['String'] | null), first?: (Scalars['Int'] | null), before?: (Scalars['String'] | null), last?: (Scalars['Int'] | null), sku: Scalars['String'], query?: (Scalars['String'] | null), filter?: (AggregationInput[] | null), defaultLanguage: Scalars['String']} })
    ping?: { __args: {message: Scalars['String']} }
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AggregationInput {value: Scalars['String'],options: Scalars['String'][]}

export interface DIYProjectIndexGenqlSelection{
    aggregations?: AggregationGenqlSelection
    connection?: DIYProjectConnectionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AggregationGenqlSelection{
    label?: boolean | number
    value?: boolean | number
    options?: AggregationOptionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AggregationOptionGenqlSelection{
    value?: boolean | number
    label?: boolean | number
    count?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DIYProjectConnectionGenqlSelection{
    /** Edges of the connection */
    edges?: DIYProjectEdgeGenqlSelection
    /** Page info of the connection */
    pageInfo?: PageInfoGenqlSelection
    /** Total count of items in the connection. */
    totalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DIYProjectEdgeGenqlSelection{
    /** Node of the Edge */
    node?: DIYProjectGenqlSelection
    /** The edge cursor */
    cursor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DIYProjectGenqlSelection{
    version?: boolean | number
    baseLanguage?: boolean | number
    firstname?: boolean | number
    keywords?: boolean | number
    projectLevel?: boolean | number
    images?: ImageGenqlSelection
    title?: boolean | number
    urlKey?: boolean | number
    customUrlKey?: boolean | number
    content?: boolean | number
    stepByStepGuide?: StepByStepGuideGenqlSelection
    orderStars?: boolean | number
    deliveryStars?: boolean | number
    generalStars?: boolean | number
    review?: boolean | number
    colorCode?: boolean | number
    tips?: boolean | number
    metaTitle?: boolean | number
    metaDescription?: boolean | number
    metaKeywords?: boolean | number
    translated?: boolean | number
    active?: boolean | number
    price?: boolean | number
    shippingPrice?: boolean | number
    isSalable?: boolean | number
    hasRestpieces?: boolean | number
    woodCategories?: CategoryGenqlSelection
    woodTypes?: BlogCategoryGenqlSelection
    spaces?: BlogCategoryGenqlSelection
    endProducts?: BlogCategoryGenqlSelection
    diyType?: BlogCategoryGenqlSelection
    categoryBrands?: BlogCategoryGenqlSelection
    products?: ProductGenqlSelection
    styles?: BlogCategoryGenqlSelection
    famousDesigners?: BlogCategoryGenqlSelection
    knownFrom?: BlogCategoryGenqlSelection
    status?: boolean | number
    highlightable?: boolean | number
    cartHash?: boolean | number
    projectCode?: boolean | number
    wordpressPostId?: boolean | number
    shortUrl?: ShortUrlGenqlSelection
    urlIdentifier?: boolean | number
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    url?: boolean | number
    hreflang?: HreflangGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ImageGenqlSelection{
    id?: boolean | number
    fullpath?: boolean | number
    filename?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StepByStepGuideGenqlSelection{
    stepDescription?: boolean | number
    phase?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CategoryGenqlSelection{
    enabled?: boolean | number
    name?: boolean | number
    urlKey?: boolean | number
    description?: boolean | number
    metaTitle?: boolean | number
    metaDescription?: boolean | number
    metaKeywords?: boolean | number
    image?: ImageGenqlSelection
    urlIdentifier?: boolean | number
    isUsedForSeo?: boolean | number
    displayType?: boolean | number
    blocks?: CategorySeoBlockGenqlSelection
    showFilters?: boolean | number
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    url?: boolean | number
    hreflang?: HreflangGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CategorySeoBlockGenqlSelection{
    title?: boolean | number
    content?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ChildrenGenqlSelection{
    on_Product?:ProductGenqlSelection,
    on_Sheet?:SheetGenqlSelection,
    on_Category?:CategoryGenqlSelection,
    on_Page?:PageGenqlSelection,
    on_FaqItem?:FaqItemGenqlSelection,
    on_FaqCategory?:FaqCategoryGenqlSelection,
    on_Stylist?:StylistGenqlSelection,
    on_DIYProject?:DIYProjectGenqlSelection,
    on_BlogCategory?:BlogCategoryGenqlSelection,
    __typename?: boolean | number
}

export interface ProductGenqlSelection{
    name?: boolean | number
    description?: boolean | number
    shortDescription?: boolean | number
    status?: boolean | number
    urlkey?: boolean | number
    customUrlKey?: boolean | number
    categoryLabel?: boolean | number
    visibility?: boolean | number
    calculatedPrice?: boolean | number
    fixedPrice?: boolean | number
    taxClass?: TaxGenqlSelection
    weightFee?: boolean | number
    yukiLedgerAccount?: boolean | number
    stockMessage?: boolean | number
    hsCode?: boolean | number
    hsCodeUnit?: boolean | number
    youtubeUrl?: boolean | number
    metaTitle?: boolean | number
    metaDescription?: boolean | number
    metaKeywords?: boolean | number
    specsheet?: ElementMetaDataSpecsheetGenqlSelection
    ean?: boolean | number
    sku?: boolean | number
    urlIdentifier?: boolean | number
    attributeSet?: boolean | number
    typeId?: boolean | number
    color?: boolean | number
    weight?: boolean | number
    brand?: boolean | number
    customJsonConfiguration?: boolean | number
    diyProjectCode?: boolean | number
    sampleService?: boolean | number
    priceType?: boolean | number
    cost?: boolean | number
    margin?: boolean | number
    minimalPrice?: boolean | number
    minimalPriceCompletePanel?: boolean | number
    minimalPriceThreshold?: boolean | number
    quantityIncrements?: boolean | number
    isInStock?: boolean | number
    alternativeProduct?: ProductGenqlSelection
    stockPosition?: boolean | number
    deliveryOffset?: boolean | number
    image?: ImageGenqlSelection
    detailImage?: ImageGenqlSelection
    gallery?: ImageGenqlSelection
    sheetTypeBase?: boolean | number
    sheetTypeFinish?: boolean | number
    sheetShapes?: ShapeGenqlSelection
    sheetFinishes?: FinishGenqlSelection
    sheetMandatoryFinishes?: FinishGenqlSelection
    sheetAvailableAbsBandColors?: boolean | number
    sheetPurchaseType?: boolean | number
    sheetThickness?: boolean | number
    sheetUnit?: boolean | number
    sheetMinLength?: boolean | number
    sheetMinWidth?: boolean | number
    sheetOutdoor?: boolean | number
    sheetPrimed?: boolean | number
    sheetWaterResistant?: boolean | number
    sheetHasVisibleSide?: boolean | number
    sheetFingerprintProof?: boolean | number
    sheetColorCode?: boolean | number
    sheetWoodQualityMark?: boolean | number
    sheetGrainType?: boolean | number
    sheetToplayerSides?: boolean | number
    sheetToplayerType?: boolean | number
    sheetTreatmentForUse?: boolean | number
    sheetQualityVisual?: boolean | number
    sheetAppearance?: boolean | number
    sheetWoodStructure?: boolean | number
    sheetWoodUsed?: boolean | number
    sheetDecorative?: boolean | number
    sheetConnectionType?: boolean | number
    sheetSustainability?: boolean | number
    sheetDensity?: boolean | number
    sheetFormaldehydeReleaseClass?: boolean | number
    sheetGlue?: boolean | number
    sheetFireResistant?: boolean | number
    sheetConditionAgreement?: boolean | number
    sheetConditionAgreementText?: boolean | number
    sheetPositiveNegative?: boolean | number
    sheetWoodApplications?: boolean | number
    sheetApplyBeltSize?: boolean | number
    sheetVeneerThickness?: boolean | number
    sheetVeneerCuttingMethod?: boolean | number
    sheetWeightPerM3?: boolean | number
    sheetJointingTechnique?: boolean | number
    sheetNcsColorCode?: boolean | number
    sheetGeneralApplication?: boolean | number
    sheetPaintability?: boolean | number
    sheetCore?: boolean | number
    sheetColorShade?: boolean | number
    sheetAlternativeOptiplanning?: boolean | number
    sheetProductionType?: boolean | number
    sheetProductionUnit?: boolean | number
    sheetWorkSpeed?: boolean | number
    sheetReverseMillingDirection?: boolean | number
    sheetPreMill?: boolean | number
    sheetTroughMill?: boolean | number
    sheetExcludeForCncProduction?: boolean | number
    sheetMinimumMiter?: boolean | number
    sheetMaximumMiter?: boolean | number
    sheetMinimumChamfering?: boolean | number
    sheetMaximumChamfering?: boolean | number
    sheetMinimumCompletion?: boolean | number
    sheetMaximumCompletion?: boolean | number
    sheetMinimumHollowprofile?: boolean | number
    sheetMaximimumHollowProfile?: boolean | number
    sheetMinimumQuarterRound?: boolean | number
    sheetMaximumQuarterRound?: boolean | number
    sheetDeliveryTime?: boolean | number
    accessoriesLength?: boolean | number
    accessoriesWidth?: boolean | number
    accessoriesHeight?: boolean | number
    accessoriesDiameter?: boolean | number
    accessoriesBitType?: boolean | number
    accessoriesPackagingContent?: boolean | number
    accessoriesColorCode?: boolean | number
    cabinetOuterWidth?: boolean | number
    cabinetOuterHeight?: boolean | number
    cabinetOuterDepth?: boolean | number
    plasticSoundDamping?: boolean | number
    plasticLightTransmission?: boolean | number
    plasticUvResistant?: boolean | number
    plasticAcrylaatType?: boolean | number
    plasticWarranty?: boolean | number
    plasticDensityGrCm3?: boolean | number
    plasticTensileNewtonMm2?: boolean | number
    plasticElasticyModulusNewtonMm2?: boolean | number
    plasticBuigsterkteNewtonMm2?: boolean | number
    plasticCompresResistanceNewtonMm2?: boolean | number
    plasticHardnessShore?: boolean | number
    plasticFrictionCoefficient?: boolean | number
    plasticTemperatureMinUnloaded?: boolean | number
    plasticTemperatureMaxUnloaded?: boolean | number
    plasticLinearExpansionCoefficient?: boolean | number
    plasticRelativeDielectricConstant?: boolean | number
    plasticDielectricLossFactor?: boolean | number
    plasticResistanceSpecific?: boolean | number
    plasticResistanceSurface?: boolean | number
    plasticBreakdownVoltage?: boolean | number
    threedimensionalTopTexture?: ImageGenqlSelection
    threedimensionalSideTexture?: ImageGenqlSelection
    categories?: CategoryGenqlSelection
    faqCategories?: FaqCategoryGenqlSelection
    crossSells?: ProductGenqlSelection
    upSells?: ProductGenqlSelection
    relatedProducts?: ProductGenqlSelection
    edgeBands?: EdgeBandGenqlSelection
    sample?: ProductGenqlSelection
    tosizeFurnitureDecor?: boolean | number
    supplier?: boolean | number
    supplierSku?: boolean | number
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    url?: boolean | number
    hreflang?: HreflangGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TaxGenqlSelection{
    name?: boolean | number
    percentage?: boolean | number
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ParentGenqlSelection{
    on_Product?:ProductGenqlSelection,
    on_Category?:CategoryGenqlSelection,
    on_Page?:PageGenqlSelection,
    on_FaqItem?:FaqItemGenqlSelection,
    on_FaqCategory?:FaqCategoryGenqlSelection,
    on_Stylist?:StylistGenqlSelection,
    __typename?: boolean | number
}

export interface PageGenqlSelection{
    enabled?: boolean | number
    title?: boolean | number
    urlKey?: boolean | number
    customUrlKey?: boolean | number
    content?: boolean | number
    intro?: boolean | number
    image?: ImageGenqlSelection
    metaTitle?: boolean | number
    metaDescription?: boolean | number
    includeInSitemap?: boolean | number
    pageRelation?: pageRelationUnionGenqlSelection
    blogCategory?: BlogCategoryGenqlSelection
    urlIdentifier?: boolean | number
    pageType?: boolean | number
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    url?: boolean | number
    hreflang?: HreflangGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface pageRelationUnionGenqlSelection{
    on_FaqCategory?:FaqCategoryGenqlSelection,
    on_FaqItem?:FaqItemGenqlSelection,
    on_Page?:PageGenqlSelection,
    __typename?: boolean | number
}

export interface FaqCategoryGenqlSelection{
    enabled?: boolean | number
    title?: boolean | number
    faqItems?: FaqItemGenqlSelection
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FaqItemGenqlSelection{
    title?: boolean | number
    content?: boolean | number
    enabled?: boolean | number
    urlKey?: boolean | number
    customUrlKey?: boolean | number
    metaTitle?: boolean | number
    metaDescription?: boolean | number
    urlIdentifier?: boolean | number
    image?: ImageGenqlSelection
    imagePosition?: boolean | number
    imageSize?: boolean | number
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    url?: boolean | number
    hreflang?: HreflangGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HreflangGenqlSelection{
    href?: boolean | number
    hreflang?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BlogCategoryGenqlSelection{
    name?: boolean | number
    urlKey?: boolean | number
    customUrlKey?: boolean | number
    description?: boolean | number
    showInMenu?: boolean | number
    enabled?: boolean | number
    image?: ImageGenqlSelection
    metaTitle?: boolean | number
    metaDescription?: boolean | number
    metaKeywords?: boolean | number
    urlIdentifier?: boolean | number
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    url?: boolean | number
    hreflang?: HreflangGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StylistGenqlSelection{
    enabled?: boolean | number
    title?: boolean | number
    urlKey?: boolean | number
    customUrlKey?: boolean | number
    personalTitle?: boolean | number
    content?: boolean | number
    speciality?: boolean | number
    formTitle?: boolean | number
    formContent?: boolean | number
    metaTitle?: boolean | number
    metaDescription?: boolean | number
    metaKeywords?: boolean | number
    gallery?: ImageGenqlSelection
    personalImage?: ImageGenqlSelection
    personalImageClose?: ImageGenqlSelection
    name?: boolean | number
    email?: boolean | number
    companyName?: boolean | number
    location?: boolean | number
    website?: LinkGenqlSelection
    latlng?: boolean | number
    youtube?: boolean | number
    facebook?: boolean | number
    instagram?: boolean | number
    pinterest?: boolean | number
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    url?: boolean | number
    hreflang?: HreflangGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LinkGenqlSelection{
    html?: boolean | number
    class?: boolean | number
    title?: boolean | number
    path?: boolean | number
    accessKey?: boolean | number
    anchor?: boolean | number
    attributes?: boolean | number
    href?: boolean | number
    rel?: boolean | number
    tabindex?: boolean | number
    target?: boolean | number
    text?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ElementMetaDataSpecsheetGenqlSelection{
    element?: AssetGenqlSelection
    variant?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssetGenqlSelection{
    id?: boolean | number
    fullpath?: boolean | number
    filename?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShapeGenqlSelection{
    code?: boolean | number
    enabled?: boolean | number
    name?: boolean | number
    description?: boolean | number
    categoryUrl?: boolean | number
    sortOrder?: boolean | number
    maxLength?: boolean | number
    maxWidth?: boolean | number
    price?: boolean | number
    image3d?: ImageGenqlSelection
    image2d?: ImageGenqlSelection
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinishGenqlSelection{
    code?: boolean | number
    name?: boolean | number
    description?: boolean | number
    shapeEnabled?: boolean | number
    categoryUrl?: boolean | number
    disallowedShapes?: ShapeGenqlSelection
    price?: boolean | number
    image2d?: ImageGenqlSelection
    image3d?: ImageGenqlSelection
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EdgeBandGenqlSelection{
    name?: boolean | number
    enabled?: boolean | number
    price?: boolean | number
    fixedPrice?: boolean | number
    taxClass?: TaxGenqlSelection
    width?: boolean | number
    thickness?: boolean | number
    stockPosition?: boolean | number
    cuttable?: boolean | number
    image?: ImageGenqlSelection
    material?: boolean | number
    decor?: boolean | number
    surface?: boolean | number
    color?: boolean | number
    priceType?: boolean | number
    cost?: boolean | number
    margin?: boolean | number
    productType?: boolean | number
    sku?: boolean | number
    minOrderLength?: boolean | number
    articleId?: boolean | number
    productId?: boolean | number
    url?: boolean | number
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SheetGenqlSelection{
    isActive?: boolean | number
    isDefault?: boolean | number
    brand?: boolean | number
    stockPosition?: boolean | number
    productionUnit?: boolean | number
    product?: ProductGenqlSelection
    priceType?: boolean | number
    cost?: boolean | number
    margin?: boolean | number
    marginCompletePanel?: boolean | number
    calculatedPrice?: boolean | number
    calculatedPriceM2CompletePanel?: boolean | number
    fixedPrice?: boolean | number
    taxClass?: TaxGenqlSelection
    weightFee?: boolean | number
    supplier?: boolean | number
    supplierProductName?: boolean | number
    supplierSku?: boolean | number
    supplierProductUrl?: boolean | number
    manufacturerProductUrl?: boolean | number
    length?: boolean | number
    width?: boolean | number
    thickness?: boolean | number
    weight?: boolean | number
    deliveryOffset?: boolean | number
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShortUrlGenqlSelection{
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Information about pagination in a connection. */
export interface PageInfoGenqlSelection{
    /** When paginating forwards, are there more items? */
    hasNextPage?: boolean | number
    /** When paginating backwards, are there more items? */
    hasPreviousPage?: boolean | number
    /** When paginating backwards, the cursor to continue. */
    startCursor?: boolean | number
    /** When paginating forwards, the cursor to continue. */
    endCursor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StylistConnectionGenqlSelection{
    /** Edges of the connection */
    edges?: StylistEdgeGenqlSelection
    /** Page info of the connection */
    pageInfo?: PageInfoGenqlSelection
    /** Total count of items in the connection. */
    totalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StylistEdgeGenqlSelection{
    /** Node of the Edge */
    node?: StylistGenqlSelection
    /** The edge cursor */
    cursor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BlogCategoryConnectionGenqlSelection{
    /** Edges of the connection */
    edges?: BlogCategoryEdgeGenqlSelection
    /** Page info of the connection */
    pageInfo?: PageInfoGenqlSelection
    /** Total count of items in the connection. */
    totalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BlogCategoryEdgeGenqlSelection{
    /** Node of the Edge */
    node?: BlogCategoryGenqlSelection
    /** The edge cursor */
    cursor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FaqItemConnectionGenqlSelection{
    /** Edges of the connection */
    edges?: FaqItemEdgeGenqlSelection
    /** Page info of the connection */
    pageInfo?: PageInfoGenqlSelection
    /** Total count of items in the connection. */
    totalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FaqItemEdgeGenqlSelection{
    /** Node of the Edge */
    node?: FaqItemGenqlSelection
    /** The edge cursor */
    cursor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FaqCategoryConnectionGenqlSelection{
    /** Edges of the connection */
    edges?: FaqCategoryEdgeGenqlSelection
    /** Page info of the connection */
    pageInfo?: PageInfoGenqlSelection
    /** Total count of items in the connection. */
    totalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FaqCategoryEdgeGenqlSelection{
    /** Node of the Edge */
    node?: FaqCategoryGenqlSelection
    /** The edge cursor */
    cursor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PageConnectionGenqlSelection{
    /** Edges of the connection */
    edges?: PageEdgeGenqlSelection
    /** Page info of the connection */
    pageInfo?: PageInfoGenqlSelection
    /** Total count of items in the connection. */
    totalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PageEdgeGenqlSelection{
    /** Node of the Edge */
    node?: PageGenqlSelection
    /** The edge cursor */
    cursor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AttributeDescriptionGenqlSelection{
    attributeCode?: boolean | number
    title?: boolean | number
    description?: boolean | number
    id?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AttributeDescriptionConnectionGenqlSelection{
    /** Edges of the connection */
    edges?: AttributeDescriptionEdgeGenqlSelection
    /** Page info of the connection */
    pageInfo?: PageInfoGenqlSelection
    /** Total count of items in the connection. */
    totalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AttributeDescriptionEdgeGenqlSelection{
    /** Node of the Edge */
    node?: AttributeDescriptionGenqlSelection
    /** The edge cursor */
    cursor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface IndexGenqlSelection{
    name?: boolean | number
    code?: boolean | number
    items?: ChildrenGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PublicEdgeBandGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    price?: boolean | number
    width?: boolean | number
    thickness?: boolean | number
    cuttable?: boolean | number
    image?: ImageGenqlSelection
    material?: boolean | number
    decor?: boolean | number
    surface?: boolean | number
    color?: boolean | number
    sku?: boolean | number
    minOrderLength?: boolean | number
    children?: ChildrenGenqlSelection
    parent?: ParentGenqlSelection
    parentId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PublicEdgeBandIndexTypeGenqlSelection{
    aggregations?: AggregationGenqlSelection
    available?: PublicEdgeBandConnectionGenqlSelection
    matching?: PublicEdgeBandGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PublicEdgeBandConnectionGenqlSelection{
    pageInfo?: PageInfoGenqlSelection
    totalCount?: boolean | number
    edges?: PublicEdgeBandEdgeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PublicEdgeBandEdgeGenqlSelection{
    node?: PublicEdgeBandGenqlSelection
    cursor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FrontendMutationGenqlSelection{
    submitAIProject?: (SubmitAIProjectResultGenqlSelection & { __args: {input: SubmitAIProjectInput} })
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SubmitAIProjectInput {hash: Scalars['String'],firstname: Scalars['String'],keywords: Scalars['String'][],level: Scalars['Int'],images: Scalars['Upload'][],colorCode?: (Scalars['String'] | null),tips?: (Scalars['String'] | null),orderStars?: (Scalars['Int'] | null),deliveryStars?: (Scalars['Int'] | null),generalStars?: (Scalars['Int'] | null),review?: (Scalars['String'] | null),stepByStepGuide?: (StepByStepGuideInput[] | null)}

export interface StepByStepGuideInput {stepDescription: Scalars['String'],phase: Scalars['String']}

export interface SubmitAIProjectResultGenqlSelection{
    project?: DIYProjectGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export type QueryGenqlSelection = FrontendQueryGenqlSelection
export type MutationGenqlSelection = FrontendMutationGenqlSelection


    const FrontendQuery_possibleTypes: string[] = ['FrontendQuery']
    export const isFrontendQuery = (obj?: { __typename?: any } | null): obj is FrontendQuery => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFrontendQuery"')
      return FrontendQuery_possibleTypes.includes(obj.__typename)
    }
    


    const DIYProjectIndex_possibleTypes: string[] = ['DIYProjectIndex']
    export const isDIYProjectIndex = (obj?: { __typename?: any } | null): obj is DIYProjectIndex => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDIYProjectIndex"')
      return DIYProjectIndex_possibleTypes.includes(obj.__typename)
    }
    


    const Aggregation_possibleTypes: string[] = ['Aggregation']
    export const isAggregation = (obj?: { __typename?: any } | null): obj is Aggregation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAggregation"')
      return Aggregation_possibleTypes.includes(obj.__typename)
    }
    


    const AggregationOption_possibleTypes: string[] = ['AggregationOption']
    export const isAggregationOption = (obj?: { __typename?: any } | null): obj is AggregationOption => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAggregationOption"')
      return AggregationOption_possibleTypes.includes(obj.__typename)
    }
    


    const DIYProjectConnection_possibleTypes: string[] = ['DIYProjectConnection']
    export const isDIYProjectConnection = (obj?: { __typename?: any } | null): obj is DIYProjectConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDIYProjectConnection"')
      return DIYProjectConnection_possibleTypes.includes(obj.__typename)
    }
    


    const DIYProjectEdge_possibleTypes: string[] = ['DIYProjectEdge']
    export const isDIYProjectEdge = (obj?: { __typename?: any } | null): obj is DIYProjectEdge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDIYProjectEdge"')
      return DIYProjectEdge_possibleTypes.includes(obj.__typename)
    }
    


    const DIYProject_possibleTypes: string[] = ['DIYProject']
    export const isDIYProject = (obj?: { __typename?: any } | null): obj is DIYProject => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDIYProject"')
      return DIYProject_possibleTypes.includes(obj.__typename)
    }
    


    const Image_possibleTypes: string[] = ['Image']
    export const isImage = (obj?: { __typename?: any } | null): obj is Image => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isImage"')
      return Image_possibleTypes.includes(obj.__typename)
    }
    


    const StepByStepGuide_possibleTypes: string[] = ['StepByStepGuide']
    export const isStepByStepGuide = (obj?: { __typename?: any } | null): obj is StepByStepGuide => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStepByStepGuide"')
      return StepByStepGuide_possibleTypes.includes(obj.__typename)
    }
    


    const Category_possibleTypes: string[] = ['Category']
    export const isCategory = (obj?: { __typename?: any } | null): obj is Category => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCategory"')
      return Category_possibleTypes.includes(obj.__typename)
    }
    


    const CategorySeoBlock_possibleTypes: string[] = ['CategorySeoBlock']
    export const isCategorySeoBlock = (obj?: { __typename?: any } | null): obj is CategorySeoBlock => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCategorySeoBlock"')
      return CategorySeoBlock_possibleTypes.includes(obj.__typename)
    }
    


    const Children_possibleTypes: string[] = ['Product','Sheet','Category','Page','FaqItem','FaqCategory','Stylist','DIYProject','BlogCategory']
    export const isChildren = (obj?: { __typename?: any } | null): obj is Children => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isChildren"')
      return Children_possibleTypes.includes(obj.__typename)
    }
    


    const Product_possibleTypes: string[] = ['Product']
    export const isProduct = (obj?: { __typename?: any } | null): obj is Product => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProduct"')
      return Product_possibleTypes.includes(obj.__typename)
    }
    


    const Tax_possibleTypes: string[] = ['Tax']
    export const isTax = (obj?: { __typename?: any } | null): obj is Tax => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTax"')
      return Tax_possibleTypes.includes(obj.__typename)
    }
    


    const Parent_possibleTypes: string[] = ['Product','Category','Page','FaqItem','FaqCategory','Stylist']
    export const isParent = (obj?: { __typename?: any } | null): obj is Parent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isParent"')
      return Parent_possibleTypes.includes(obj.__typename)
    }
    


    const Page_possibleTypes: string[] = ['Page']
    export const isPage = (obj?: { __typename?: any } | null): obj is Page => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPage"')
      return Page_possibleTypes.includes(obj.__typename)
    }
    


    const pageRelationUnion_possibleTypes: string[] = ['FaqCategory','FaqItem','Page']
    export const ispageRelationUnion = (obj?: { __typename?: any } | null): obj is pageRelationUnion => {
      if (!obj?.__typename) throw new Error('__typename is missing in "ispageRelationUnion"')
      return pageRelationUnion_possibleTypes.includes(obj.__typename)
    }
    


    const FaqCategory_possibleTypes: string[] = ['FaqCategory']
    export const isFaqCategory = (obj?: { __typename?: any } | null): obj is FaqCategory => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFaqCategory"')
      return FaqCategory_possibleTypes.includes(obj.__typename)
    }
    


    const FaqItem_possibleTypes: string[] = ['FaqItem']
    export const isFaqItem = (obj?: { __typename?: any } | null): obj is FaqItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFaqItem"')
      return FaqItem_possibleTypes.includes(obj.__typename)
    }
    


    const Hreflang_possibleTypes: string[] = ['Hreflang']
    export const isHreflang = (obj?: { __typename?: any } | null): obj is Hreflang => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHreflang"')
      return Hreflang_possibleTypes.includes(obj.__typename)
    }
    


    const BlogCategory_possibleTypes: string[] = ['BlogCategory']
    export const isBlogCategory = (obj?: { __typename?: any } | null): obj is BlogCategory => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBlogCategory"')
      return BlogCategory_possibleTypes.includes(obj.__typename)
    }
    


    const Stylist_possibleTypes: string[] = ['Stylist']
    export const isStylist = (obj?: { __typename?: any } | null): obj is Stylist => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStylist"')
      return Stylist_possibleTypes.includes(obj.__typename)
    }
    


    const Link_possibleTypes: string[] = ['Link']
    export const isLink = (obj?: { __typename?: any } | null): obj is Link => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLink"')
      return Link_possibleTypes.includes(obj.__typename)
    }
    


    const ElementMetaDataSpecsheet_possibleTypes: string[] = ['ElementMetaDataSpecsheet']
    export const isElementMetaDataSpecsheet = (obj?: { __typename?: any } | null): obj is ElementMetaDataSpecsheet => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isElementMetaDataSpecsheet"')
      return ElementMetaDataSpecsheet_possibleTypes.includes(obj.__typename)
    }
    


    const Asset_possibleTypes: string[] = ['Asset']
    export const isAsset = (obj?: { __typename?: any } | null): obj is Asset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAsset"')
      return Asset_possibleTypes.includes(obj.__typename)
    }
    


    const Shape_possibleTypes: string[] = ['Shape']
    export const isShape = (obj?: { __typename?: any } | null): obj is Shape => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShape"')
      return Shape_possibleTypes.includes(obj.__typename)
    }
    


    const Finish_possibleTypes: string[] = ['Finish']
    export const isFinish = (obj?: { __typename?: any } | null): obj is Finish => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinish"')
      return Finish_possibleTypes.includes(obj.__typename)
    }
    


    const EdgeBand_possibleTypes: string[] = ['EdgeBand']
    export const isEdgeBand = (obj?: { __typename?: any } | null): obj is EdgeBand => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEdgeBand"')
      return EdgeBand_possibleTypes.includes(obj.__typename)
    }
    


    const Sheet_possibleTypes: string[] = ['Sheet']
    export const isSheet = (obj?: { __typename?: any } | null): obj is Sheet => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSheet"')
      return Sheet_possibleTypes.includes(obj.__typename)
    }
    


    const ShortUrl_possibleTypes: string[] = ['ShortUrl']
    export const isShortUrl = (obj?: { __typename?: any } | null): obj is ShortUrl => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShortUrl"')
      return ShortUrl_possibleTypes.includes(obj.__typename)
    }
    


    const PageInfo_possibleTypes: string[] = ['PageInfo']
    export const isPageInfo = (obj?: { __typename?: any } | null): obj is PageInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPageInfo"')
      return PageInfo_possibleTypes.includes(obj.__typename)
    }
    


    const StylistConnection_possibleTypes: string[] = ['StylistConnection']
    export const isStylistConnection = (obj?: { __typename?: any } | null): obj is StylistConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStylistConnection"')
      return StylistConnection_possibleTypes.includes(obj.__typename)
    }
    


    const StylistEdge_possibleTypes: string[] = ['StylistEdge']
    export const isStylistEdge = (obj?: { __typename?: any } | null): obj is StylistEdge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStylistEdge"')
      return StylistEdge_possibleTypes.includes(obj.__typename)
    }
    


    const BlogCategoryConnection_possibleTypes: string[] = ['BlogCategoryConnection']
    export const isBlogCategoryConnection = (obj?: { __typename?: any } | null): obj is BlogCategoryConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBlogCategoryConnection"')
      return BlogCategoryConnection_possibleTypes.includes(obj.__typename)
    }
    


    const BlogCategoryEdge_possibleTypes: string[] = ['BlogCategoryEdge']
    export const isBlogCategoryEdge = (obj?: { __typename?: any } | null): obj is BlogCategoryEdge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBlogCategoryEdge"')
      return BlogCategoryEdge_possibleTypes.includes(obj.__typename)
    }
    


    const FaqItemConnection_possibleTypes: string[] = ['FaqItemConnection']
    export const isFaqItemConnection = (obj?: { __typename?: any } | null): obj is FaqItemConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFaqItemConnection"')
      return FaqItemConnection_possibleTypes.includes(obj.__typename)
    }
    


    const FaqItemEdge_possibleTypes: string[] = ['FaqItemEdge']
    export const isFaqItemEdge = (obj?: { __typename?: any } | null): obj is FaqItemEdge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFaqItemEdge"')
      return FaqItemEdge_possibleTypes.includes(obj.__typename)
    }
    


    const FaqCategoryConnection_possibleTypes: string[] = ['FaqCategoryConnection']
    export const isFaqCategoryConnection = (obj?: { __typename?: any } | null): obj is FaqCategoryConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFaqCategoryConnection"')
      return FaqCategoryConnection_possibleTypes.includes(obj.__typename)
    }
    


    const FaqCategoryEdge_possibleTypes: string[] = ['FaqCategoryEdge']
    export const isFaqCategoryEdge = (obj?: { __typename?: any } | null): obj is FaqCategoryEdge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFaqCategoryEdge"')
      return FaqCategoryEdge_possibleTypes.includes(obj.__typename)
    }
    


    const PageConnection_possibleTypes: string[] = ['PageConnection']
    export const isPageConnection = (obj?: { __typename?: any } | null): obj is PageConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPageConnection"')
      return PageConnection_possibleTypes.includes(obj.__typename)
    }
    


    const PageEdge_possibleTypes: string[] = ['PageEdge']
    export const isPageEdge = (obj?: { __typename?: any } | null): obj is PageEdge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPageEdge"')
      return PageEdge_possibleTypes.includes(obj.__typename)
    }
    


    const AttributeDescription_possibleTypes: string[] = ['AttributeDescription']
    export const isAttributeDescription = (obj?: { __typename?: any } | null): obj is AttributeDescription => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAttributeDescription"')
      return AttributeDescription_possibleTypes.includes(obj.__typename)
    }
    


    const AttributeDescriptionConnection_possibleTypes: string[] = ['AttributeDescriptionConnection']
    export const isAttributeDescriptionConnection = (obj?: { __typename?: any } | null): obj is AttributeDescriptionConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAttributeDescriptionConnection"')
      return AttributeDescriptionConnection_possibleTypes.includes(obj.__typename)
    }
    


    const AttributeDescriptionEdge_possibleTypes: string[] = ['AttributeDescriptionEdge']
    export const isAttributeDescriptionEdge = (obj?: { __typename?: any } | null): obj is AttributeDescriptionEdge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAttributeDescriptionEdge"')
      return AttributeDescriptionEdge_possibleTypes.includes(obj.__typename)
    }
    


    const Index_possibleTypes: string[] = ['Index']
    export const isIndex = (obj?: { __typename?: any } | null): obj is Index => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIndex"')
      return Index_possibleTypes.includes(obj.__typename)
    }
    


    const PublicEdgeBand_possibleTypes: string[] = ['PublicEdgeBand']
    export const isPublicEdgeBand = (obj?: { __typename?: any } | null): obj is PublicEdgeBand => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPublicEdgeBand"')
      return PublicEdgeBand_possibleTypes.includes(obj.__typename)
    }
    


    const PublicEdgeBandIndexType_possibleTypes: string[] = ['PublicEdgeBandIndexType']
    export const isPublicEdgeBandIndexType = (obj?: { __typename?: any } | null): obj is PublicEdgeBandIndexType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPublicEdgeBandIndexType"')
      return PublicEdgeBandIndexType_possibleTypes.includes(obj.__typename)
    }
    


    const PublicEdgeBandConnection_possibleTypes: string[] = ['PublicEdgeBandConnection']
    export const isPublicEdgeBandConnection = (obj?: { __typename?: any } | null): obj is PublicEdgeBandConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPublicEdgeBandConnection"')
      return PublicEdgeBandConnection_possibleTypes.includes(obj.__typename)
    }
    


    const PublicEdgeBandEdge_possibleTypes: string[] = ['PublicEdgeBandEdge']
    export const isPublicEdgeBandEdge = (obj?: { __typename?: any } | null): obj is PublicEdgeBandEdge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPublicEdgeBandEdge"')
      return PublicEdgeBandEdge_possibleTypes.includes(obj.__typename)
    }
    


    const FrontendMutation_possibleTypes: string[] = ['FrontendMutation']
    export const isFrontendMutation = (obj?: { __typename?: any } | null): obj is FrontendMutation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFrontendMutation"')
      return FrontendMutation_possibleTypes.includes(obj.__typename)
    }
    


    const SubmitAIProjectResult_possibleTypes: string[] = ['SubmitAIProjectResult']
    export const isSubmitAIProjectResult = (obj?: { __typename?: any } | null): obj is SubmitAIProjectResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSubmitAIProjectResult"')
      return SubmitAIProjectResult_possibleTypes.includes(obj.__typename)
    }
    

export const enumSortOrder = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}
